// Decimal-safe helpers working in integer cents. Money strings come from the API.
import type { Money } from "./types";

export function toCents(value: Money | number | null | undefined): number {
  if (value === null || value === undefined || value === "") return 0;
  const s = typeof value === "number" ? value.toFixed(2) : value.trim();
  const neg = s.startsWith("-");
  const [int = "0", frac = ""] = s.replace("-", "").replace(/,/g, "").split(".");
  const cents = Number(int) * 100 + Number((frac + "00").slice(0, 2));
  return neg ? -cents : cents;
}

export function fromCents(cents: number): Money {
  const neg = cents < 0;
  const abs = Math.abs(Math.round(cents));
  return `${neg ? "-" : ""}${Math.floor(abs / 100)}.${String(abs % 100).padStart(2, "0")}`;
}

export const sum = (values: (Money | null | undefined)[]): Money =>
  fromCents(values.reduce((acc, v) => acc + toCents(v), 0));

export const ratio = (part: Money, whole: Money): number => {
  const w = toCents(whole);
  return w === 0 ? 0 : toCents(part) / w;
};

/** Normalize user input like "1,234.5" or "$ 99" into a Money string, or null if invalid. */
export function parseMoneyInput(raw: string): Money | null {
  const cleaned = raw.replace(/[$\s,]/g, "");
  if (!/^-?\d+(\.\d{0,2})?$/.test(cleaned)) return null;
  return fromCents(toCents(cleaned));
}
